module.exports = __webpack_public_path__ + "img/bg_together.4228295b.png";